import React, { useState, useEffect } from 'react'
// import { useLocation } from 'react-router-dom'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import {
  searchWaitScrutinize,
  getProjectListSchema,
  createReviewGroup,
} from '../../../redux/actions/multiReview'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ProjectDataTable from '../../../widgets/dataTable/ProjectDataTable'
import SearchProjectInformation from '../../../widgets/search/SearchProjectInformation'
import { cloneDeep } from 'lodash'
import { getProposalForm } from '../../../redux/actions/filesManagement'
import PdfRenderWidgets from '../../../widgets/pdfWidgets/PdfRenderWidgets'
import { useHistory, useParams } from 'react-router-dom'
import { isNewMultiReveiw } from '../../../utils/ValidatorUtils'
import pathname from '../../../constants/pathname'

export default function ProjectList(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [isSubmitLoading, setIsSubmitLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [pdfRender, setPdfRender] = useState()
  // const [selectList, setSelectList] = useState([])

  const [searchResultLoading, setSearchResultLoading] = useState(false)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const isEnableEdit = isNewMultiReveiw(projectId)

  let history = useHistory()

  useEffect(() => {
    let idList = sessionStorage.getItem('mutiReview')

    const request = {
      id: idList,
    }

    handleGetSchema(request)
  }, [])

  const handleGetSchema = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      console.log('handleGetSchema request', request)
      const response = await getProjectListSchema(request)
      console.log('handleGetSchema response', response)

      setSchema(response)
    } catch (e) {
      console.log('e', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleSearch = async (request, pagesize, pagenumber) => {
    setSearchResultLoading(true)
    startLoading()
    try {
      console.log('request', request, 'pagesize', pagesize, 'pagenumber', pagenumber)
      let _schema = schema
      const response = await searchWaitScrutinize(request, pagesize, pagenumber)
      _schema.forms['projectSearchResult'] = response

      _schema.forms.projectSearchPanal.projectCode.value = request.projectCode
      _schema.forms.projectSearchPanal.projectName.value = request.projectName
      // _schema.forms.projectSearchPanal.projectType.value = request.projectType
      _schema.forms.projectSearchPanal.projectBudget.value = request.projectBudget
      _schema.forms.projectSearchPanal.projectTemplete.value = request.projectTemplete
      // console.log('handleSearch _schema', _schema)

      setSchema(_schema)
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setSearchResultLoading(false)
  }

  const onReload = (pagesize, pagenumber) => {
    const request = {
      projectcode: schema.forms.projectSearchPanal.projectCode.value,
      projectName: schema.forms.projectSearchPanal.projectName.value,
      // projectType: schema.forms.projectSearchPanal.projectType.value,
      projectBudget: schema.forms.projectSearchPanal.projectBudget.value,
      projectTemplete: schema.forms.projectSearchPanal.projectTemplete.value,
    }

    handleSearch(request, pagesize, pagenumber)
  }

  const onSearch = (data) => {
    console.log('onSearch : ', data)

    const request = {
      projectCode: data.projectCode,
      projectName: data.projectName,
      // projectType: data.projectType,
      projectBudget: data.projectBudget,
      projectTemplete: data.projectTemplete,
    }

    handleSearch(request, 5, 1)
  }

  const onClean = () => {
    let _schema = cloneDeep(schema)

    _schema.forms.projectSearchPanal.projectCode.value = ''
    _schema.forms.projectSearchPanal.projectName.value = ''
    // _schema.forms.projectSearchPanal.projectType.value = ''
    _schema.forms.projectSearchPanal.projectBudget.value = ''
    _schema.forms.projectSearchPanal.projectTemplete.value = ''
    _schema.forms['projectSearchResult'] = ''

    console.log('onClean _schema', _schema)

    setSchema(_schema)
  }

  const handleSelect = (selectList) => {
    let _schema = cloneDeep(schema)

    let waitingScrutinized = schema.forms.waitingScrutinized.values

    for (let index = 0; index < selectList.length; index++) {
      const element = selectList[index]
      let isDuplicate = waitingScrutinized.some((e) => e.id === element.id)

      if (!isDuplicate) {
        waitingScrutinized.push(element)
      }
    }

    _schema.forms.waitingScrutinized.values = waitingScrutinized
    _schema.forms.waitingScrutinized.totalSize = waitingScrutinized.length
    // console.log('waitingScrutinized', waitingScrutinized)

    setSessionStor(waitingScrutinized)
    setSchema(_schema)
  }

  const onView = async (id) => {
    console.log('onView', id)
    startLoading()

    try {
      const filePDF = await getProposalForm(id)
      setPdfRender(filePDF)
      console.log('filePDF', filePDF)
    } catch (e) {
      console.log('e', e)
    }

    doneLoading()
    // setIsLoading(false)
  }

  const onRemove = (obj) => {
    console.log('onRemove', obj)
    let _schema = schema
    let waitingScrutinized = [...cloneDeep(schema.forms.waitingScrutinized.values)]

    let deleteIndex = waitingScrutinized.findIndex((item) => item.id == obj.id)
    // console.log(deleteIndex)
    deleteIndex >= 0 && waitingScrutinized.splice(deleteIndex, 1)

    _schema.forms.waitingScrutinized.values = waitingScrutinized
    _schema.forms.waitingScrutinized.totalSize = waitingScrutinized.length

    setSessionStor(waitingScrutinized)
    setSchema(_schema)
  }

  const setSessionStor = (dataList) => {
    let idList = dataList.map((item) => {
      return item.id
    })

    sessionStorage.setItem('mutiReview', idList)
  }

  const onSubmit = async () => {
    setIsSubmitLoading(true)
    startLoading()

    let projectIds = sessionStorage.getItem('mutiReview')

    const request = {
      projectVersionIds: projectIds?.split(','),
      groupId: projectId == 'multi-reveiw' ? '' : projectId,
    }

    try {
      const response = await createReviewGroup(request)
      //console.log('response=', response)
      //sessionStorage.removeItem('mutiReview')
      // history.push(`${pathname.proposal.review.strategicMulti}/${response.model.id}`)
      sessionStorage.setItem('projectId', response.model.id)
      history.push(`${pathname.proposal.review.strategicMulti}`)
    } catch (error) {}

    doneLoading()
    setIsSubmitLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isMultiReview>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isMultiReview>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isMultiReview>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

      {isEnableEdit && schema?.forms?.projectSearchPanal && (
        <>
          <SearchProjectInformation
            schema={schema.forms.projectSearchPanal}
            onSearch={onSearch}
            onClean={onClean}
            hideProjectType
          />
          <br />
        </>
      )}

      {schema?.forms?.projectSearchResult && (
        <>
          <ProjectDataTable
            schema={schema.forms.projectSearchResult}
            multi={{
              enable: true,
              buttonText: `เพิ่ม${
                schema.forms.waitingScrutinized.mutiButtonText || 'ไปยังการกลั่นกรอง'
              }`,
              icon: 'plus',
            }}
            onMultiSubmit={handleSelect}
            onReload={onReload}
            pagination={true}
            loading={searchResultLoading}
          />
          <br />
        </>
      )}

      {schema?.forms?.waitingScrutinized && (
        <>
          <ProjectDataTable
            schema={schema.forms.waitingScrutinized}
            enableView={true}
            onView={onView}
            onRemove={isEnableEdit && onRemove}
            pagination={true}
            submit={{
              enable: true,
              buttonText: `บันทึกร่างกลั่นกรองหลายโครงการ`,
            }}
            onSubmit={onSubmit}
            isSubmitLoading={isSubmitLoading}
          />
          <br />
        </>
      )}

      {pdfRender && (
        <>
          <PdfRenderWidgets
            header={'แสดงตัวอย่างก่อนพิมพ์ ข้อเสนอโครงการ'}
            file={pdfRender}
            isLoading={isLoading}
          />
          <br />
        </>
      )}
    </SidebarProposal>
  )
}
